<template>
  <div class="makercart-cart-page">
    <div class="mobile-top-app-bar" v-if="!showAuthSection">
      <button
        class="mobile-top-app-bar__icon"
        type="button"
        aria-label="Back"
        @click="goBack"
      >
        <img
          src="/images/icon/arrow-circle-left.svg"
          alt=""
          aria-hidden="true"
        />
      </button>
      <div class="mobile-top-app-bar__title">View Cart</div>
      <div class="mobile-top-app-bar__icon">
        <img src="/images/icon/question-mark-circle.svg" alt="Help" />
      </div>
    </div>
    <div class="header-section">
      <template v-if="!isAuthenticated || showProgressBarAfterAuth">
        <!-- Progress Bar -->
        <div class="cart-progress-bar">
          <div class="progress-section">
            <svg
              v-if="
                showAuthSection || (isAuthenticated && showProgressBarAfterAuth)
              "
              aria-hidden="true"
              width="40"
              height="41"
              viewBox="0 0 40 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                y="0.497559"
                width="40"
                height="40"
                rx="20"
                fill="#00925E"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32.0727 12.0248C32.7756 12.7277 32.7756 13.8674 32.0727 14.5704L17.6727 28.9704C16.9698 29.6733 15.8301 29.6733 15.1271 28.9704L7.92711 21.7704C7.22417 21.0674 7.22417 19.9277 7.92711 19.2248C8.63005 18.5218 9.76975 18.5218 10.4727 19.2248L16.3999 25.152L29.5271 12.0248C30.2301 11.3218 31.3698 11.3218 32.0727 12.0248Z"
                fill="white"
              />
            </svg>

            <div v-else class="progress-icon active">
              <div class="icon-border"></div>
            </div>
            <div class="progress-label active">Review Cart</div>
          </div>

          <div
            class="progress-line"
            :class="{
              'active-progress-line':
                showAuthSection ||
                (isAuthenticated && showProgressBarAfterAuth),
            }"
          ></div>

          <div class="progress-section">
            <svg
              v-if="isAuthenticated && showProgressBarAfterAuth"
              aria-hidden="true"
              width="40"
              height="41"
              viewBox="0 0 40 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                y="0.497559"
                width="40"
                height="40"
                rx="20"
                fill="#00925E"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32.0727 12.0248C32.7756 12.7277 32.7756 13.8674 32.0727 14.5704L17.6727 28.9704C16.9698 29.6733 15.8301 29.6733 15.1271 28.9704L7.92711 21.7704C7.22417 21.0674 7.22417 19.9277 7.92711 19.2248C8.63005 18.5218 9.76975 18.5218 10.4727 19.2248L16.3999 25.152L29.5271 12.0248C30.2301 11.3218 31.3698 11.3218 32.0727 12.0248Z"
                fill="white"
              />
            </svg>
            <div
              v-else
              class="progress-icon"
              :class="{ active: showAuthSection, inactive: !showAuthSection }"
            >
              <div
                class="icon-border"
                :class="{ inactive: !showAuthSection }"
              ></div>
            </div>
            <div
              class="progress-label"
              :class="{
                active:
                  showAuthSection ||
                  (isAuthenticated && showProgressBarAfterAuth),
                inactive:
                  !showAuthSection &&
                  !(isAuthenticated && showProgressBarAfterAuth),
              }"
            >
              <span class="progress-label-desktop">Login/Signup</span>
              <span class="progress-label-mobile">Email</span>
            </div>
          </div>

          <div
            class="progress-line"
            :class="{ 'active-progress-line': quoteGenerated }"
          ></div>

          <div class="progress-section">
            <svg
              v-if="quoteGenerated"
              aria-hidden="true"
              width="40"
              height="41"
              viewBox="0 0 40 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                y="0.497559"
                width="40"
                height="40"
                rx="20"
                fill="#00925E"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32.0727 12.0248C32.7756 12.7277 32.7756 13.8674 32.0727 14.5704L17.6727 28.9704C16.9698 29.6733 15.8301 29.6733 15.1271 28.9704L7.92711 21.7704C7.22417 21.0674 7.22417 19.9277 7.92711 19.2248C8.63005 18.5218 9.76975 18.5218 10.4727 19.2248L16.3999 25.152L29.5271 12.0248C30.2301 11.3218 31.3698 11.3218 32.0727 12.0248Z"
                fill="white"
              />
            </svg>
            <div
              v-else
              class="progress-icon"
              :class="{ active: quoteGenerated, inactive: !quoteGenerated }"
            >
              <div
                class="icon-border"
                :class="{ inactive: !quoteGenerated }"
              ></div>
            </div>
            <div
              class="progress-label"
              :class="{ active: quoteGenerated, inactive: !quoteGenerated }"
            >
              <span class="progress-label-desktop">Checkout Successful</span>
              <span class="progress-label-mobile">Request Quote</span>
            </div>
          </div>
        </div>
        <!-- Divider Line -->
        <div class="divider-line"></div>
      </template>

      <!-- Back Button -->
      <div
        class="back-button-container"
        role="button"
        tabindex="0"
        aria-label="Go Back"
        @click="goBack"
        @keydown.enter="goBack"
        @keydown.space.prevent="goBack"
      >
        <div class="back-icon" aria-hidden="true">
          <img src="/images/icon/arrow-circle-left.svg" alt="" />
        </div>
        <div class="back-text">Back</div>
      </div>

      <!-- Cart Header -->
      <CartHeader
        :quoteGenerated="quoteGenerated"
        :locale="locale"
        :hasBundledActivities="hasBundledActivities"
        :tipBannerMessage="tipBannerMessage"
        @addNewCart="addNewCart"
        @addActivity="addActivity"
        :showAuthSection="showAuthSection"
      />
    </div>

    <!-- Cart Summary Section -->
    <div class="cart-summary-section">
      <!-- Authentication Section (shown when user is not authenticated and clicked Checkout or Request Quote) -->
      <div
        v-if="!isAuthenticated && showAuthSection"
        class="auth-section-container"
      >
        <AuthSection
          ref="authSectionRef"
          initial-view="login"
          @login-success="handleAuthSuccess"
          @email-verified="handleAuthSuccess"
          @guest-login-success="handleGuestAuthSuccess"
        />
      </div>

      <div v-else class="cart-content-area">
        <!-- Empty Cart State -->
        <EmptyCartState
          v-if="!hasCart && !hasMakercrates"
          @addNewCart="addNewCart"
        />

        <!-- Multiple Carts State -->
        <div
          v-if="hasCart || hasSignatureMakercarts || hasMakercrates"
          class="carts-container"
        >
          <!-- Makercrates (pre-built kits) -->
          <MakercrateCartItem
            v-for="cart in makercrates"
            :key="`makercrate-${cart.id}`"
            :cart="cart"
            :quoteGenerated="quoteGenerated"
            :isUpdatingQuantity="isUpdatingQuantity[cart.id]"
            @edit-name="handleStartEditingCartName"
            @save-name="handleSaveCartName"
            @cancel-edit-name="handleCancelEditCartName"
            @decrease-quantity="
              (id) => handleDecreaseQuantity(id, 'makercrate')
            "
            @increase-quantity="
              (id) => handleIncreaseQuantity(id, 'makercrate')
            "
            @delete-cart="handleDeleteMakercrateClick"
            @toggle-view="toggleMakercrateView"
          />

          <!-- Signature Makercarts -->
          <CartItem
            v-for="cart in signatureMakercarts"
            :key="cart.id"
            :cart="cart"
            type="signature"
            :isCartLoading="isCartLoading"
            :isUpdatingQuantity="isUpdatingQuantity[cart.id]"
            :quoteGenerated="quoteGenerated"
            :availableCarts="availableCarts"
            @edit-name="handleStartEditingCartName"
            @save-name="handleSaveCartName"
            @cancel-edit-name="handleCancelEditCartName"
            @decrease-quantity="handleDecreaseQuantity"
            @increase-quantity="handleIncreaseQuantity"
            @quantity-input="handleQuantityInput"
            @quantity-blur="handleQuantityBlur"
            @delete-cart="handleDeleteClick"
            @duplicate-cart="handleDuplicateClick"
            @toggle-view="toggleCartView"
            @edit-activity="handleEditActivity"
            @remove-activity="handleRemoveActivity"
            @activity-converted="handleActivityConverted"
            @add-activity="addActivity"
          />

          <!-- Custom Makercarts -->
          <CartItem
            v-for="cart in carts"
            :key="cart.id"
            :cart="cart"
            type="custom"
            :isCartLoading="isCartLoading"
            :isUpdatingQuantity="isUpdatingQuantity[cart.id]"
            :quoteGenerated="quoteGenerated"
            :availableCarts="availableCarts"
            @edit-name="handleStartEditingCartName"
            @save-name="handleSaveCartName"
            @cancel-edit-name="handleCancelEditCartName"
            @decrease-quantity="handleDecreaseQuantity"
            @increase-quantity="handleIncreaseQuantity"
            @quantity-input="handleQuantityInput"
            @quantity-blur="handleQuantityBlur"
            @delete-cart="handleDeleteClick"
            @duplicate-cart="handleDuplicateClick"
            @toggle-view="toggleCartView"
            @edit-activity="handleEditActivity"
            @remove-activity="handleRemoveActivity"
            @add-activity="addActivity"
          />
        </div>

        <!-- Single Activity Section -->
        <SingleActivitySection
          v-if="singleActivities.length > 0 && locale !== 'SG'"
          :singleActivities="singleActivities"
          :hasSingleActivities="hasSingleActivities"
          @addActivity="addActivity"
          @bundleActivities="handleBundleActivities"
          @moveActivity="handleMoveSingleActivity"
          @deleteActivity="handleDeleteSingleActivity"
        />
      </div>

      <!-- Price Summary -->
      <OrderSummary
        v-if="!showAuthSection"
        :total="total"
        :locale="locale"
        :localeCurrency="localeCurrency"
        :showQuoteForm="showQuoteForm"
        :quoteGenerated="quoteGenerated"
        :quoteFormData="quoteFormData"
        :isFormValid="isFormValid"
        :isRequestingQuote="isRequestingQuote"
        :isDownloadingQuote="isDownloadingQuote"
        :isSendingQuote="isSendingQuote"
        :hasBundledActivities="hasBundledActivities"
        :hasSignatureMakercarts="hasSignatureMakercarts"
        :hasSingleActivities="hasSingleActivities"
        :hasMakercrates="hasMakercrates"
        :isMakercrateOnlyCart="isMakercrateOnlyCart"
        @checkout="handleMakercrateInstantCheckout"
        @request-quote="handleRequestQuote"
        @cancel-quote="handleCancelQuote"
        @download-quote="handleDownloadQuote"
        @resend-quote="handleResendQuote"
        @update:quoteFormData="(newData) => (quoteFormData = newData)"
        :totalActivities="totalActivities"
      />
    </div>

    <!-- Confirmation Modals -->
    <DeleteModal
      v-model="showDeleteModal"
      title="Delete Cart"
      description="Are you sure you want to delete this cart?"
      confirm-text="Delete Cart"
      cancel-text="Back"
      :loading="isCartLoading"
      @confirm="handleDeleteConfirm"
      @cancel="handleDeleteCancel"
    />

    <DeleteModal
      v-model="showDeleteMakercrateModal"
      title="Delete Makercrate"
      description="Are you sure you want to remove this kit from your cart?"
      confirm-text="Delete Makercrate"
      cancel-text="Back"
      :loading="isCartLoading"
      @confirm="handleDeleteMakercrateConfirm"
      @cancel="handleDeleteMakercrateCancel"
    />

    <DuplicateModal
      v-model="showDuplicateModal"
      title="Duplicate Cart"
      description="This will create a copy of the cart with all its activities. Are you sure you want to duplicate it?"
      confirm-text="Duplicate Cart"
      cancel-text="Back"
      :loading="isCartLoading"
      @confirm="handleDuplicateConfirm"
      @cancel="handleDuplicateCancel"
    />

    <MoveActivityModal
      v-model="showMoveModal"
      :available-carts="availableCarts"
      :current-cart-id="null"
      :activity-data="selectedActivity"
      :loading="isCartLoading"
      @move="handleMoveActivity"
      @cancel="handleMoveCancel"
    />

    <ConfirmationModal
      v-model="showBundleModal"
      title="Bundle Single Activities"
      :description="bundleConfirmationMessage"
      confirm-text="Bundle Activities"
      cancel-text="Cancel"
      :loading="isCartLoading"
      @confirm="handleBundleConfirm"
      @cancel="handleBundleCancel"
    />

    <SendQuoteModal
      v-model="showSendQuoteModal"
      @send="handleSendQuote"
      @cancel="handleSendQuoteCancel"
    />

    <!-- Delete Single Activity Modal -->
    <DeleteModal
      v-model="showDeleteSingleActivityModal"
      title="Delete Activity"
      description="Are you sure want to delete this activity?"
      confirm-text="Delete Activity"
      cancel-text="Back"
      :loading="isCartLoading"
      @confirm="handleDeleteSingleActivityConfirm"
      @cancel="handleDeleteSingleActivityCancel"
    />

    <QuoteRequestedModal
      v-model="showQuoteRequestedModal"
      @close="showQuoteRequestedModal = false"
    />

    <!-- ChatbotAssistant - hidden when any modal is open -->
    <ChatbotAssistant position="right" page-name="Catalog" />
  </div>
</template>

<script setup>
/* eslint-disable */
import AuthSection from "@/components/maker-cart/AuthSection.vue";
import ConfirmationModal from "@/components/maker-cart/carts/ConfirmationModal.vue";
import DeleteModal from "@/components/maker-cart/carts/DeleteModal.vue";
import DuplicateModal from "@/components/maker-cart/carts/DuplicateModal.vue";
import MoveActivityModal from "@/components/maker-cart/carts/MoveActivityModal.vue";
import SendQuoteModal from "@/components/maker-cart/carts/SendQuoteModal.vue";
import ChatbotAssistant from "@/components/maker-cart/ChatbotAssistant.vue";
import QuoteRequestedModal from "@/components/maker-cart/carts/QuoteRequestedModal.vue";
import SGCart from "@/components/maker-cart/carts/SGCart.vue";
import CartHeader from "@/components/maker-cart/carts/CartHeader.vue";
import EmptyCartState from "@/components/maker-cart/carts/EmptyCartState.vue";
import CartItem from "@/components/maker-cart/carts/CartItem.vue";
import MakercrateCartItem from "@/components/maker-cart/carts/MakercrateCartItem.vue";
import SingleActivitySection from "@/components/maker-cart/carts/SingleActivitySection.vue";
import OrderSummary from "@/components/maker-cart/carts/OrderSummary.vue";

import { useCart } from "@/composeables/useCart";
import { useUserState } from "@/composeables/useUserState";
import userCartService from "@/services/userCartService";
import { computed, inject, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useMakercartSession } from "@/composeables/useMakercartSession";
import { useLocaleStore } from "@/store/locale";

const router = useRouter();

const notify = inject("notify");
const store = useStore();
const user = computed(() => store.state.user);
const isAuthenticated = ref(!!user.value);
const showAuthSection = ref(false);
const authSectionRef = ref(null);
const showProgressBarAfterAuth = ref(false);
const { isAuthenticated: isUserAuthenticated, updateUserState } =
  useUserState();

// Session tracking
const { trackProcessStep, trackQuoteGeneratedStep } = useMakercartSession();

const localeStore = useLocaleStore();

const localeCurrency = computed(() => localeStore.getLocaleCurrency());
const locale = computed(() => localeStore.currentLocale);

// Use the refactored useCart composable
const {
  makercarts: carts,
  signatureMakercarts,
  makercrates,
  hasMakercrates,
  toggleMakercrateView,
  findEditableCart,
  total,
  singleActivities,
  totalActivities,
  hasMakercart: hasCart,
  availableCarts,
  addNewMakercart: addNewCart,
  deleteMakercart: deleteCart,
  duplicateMakercart: duplicateCart,
  startEditingCartName,
  finishEditingCartName,
  toggleCartView,
  handleMakercartSelection,
  removeSingleActivity,
  calculateBundledSubtotal,
  quoteGenerated,
  requestQuote,
  resetCart,
  convertSingleToBundle,
  isCartLoading,
  cartId,
  syncCartWithAPI,
} = useCart();

// Computed properties for price calculations
const bundledSubtotal = computed(() => calculateBundledSubtotal());

const hasSingleActivities = computed(
  () => singleActivities.value.length > 0 && locale.value !== "SG"
);
const hasBundledActivities = computed(() => bundledSubtotal.value > 0);
const hasSignatureMakercarts = computed(
  () => signatureMakercarts.value.length > 0
);

const isMakercrateOnlyCart = computed(
  () =>
    hasMakercrates.value &&
    !(carts.value || []).length &&
    !(signatureMakercarts.value || []).length &&
    !hasSingleActivities.value
);

const bundleConfirmationMessage = computed(() => {
  const count = singleActivities.value.length;
  if (count === 0) {
    return "No single activities to bundle.";
  } else if (count === 1) {
    return "This will bundle your single activity into a new Makercart. This will save you money compared to buying it individually. Are you sure you want to continue?";
  } else {
    return `This will bundle all ${count} single activities into a new Makercart. This will save you money compared to buying them individually. Are you sure you want to continue?`;
  }
});

const tipBannerMessage = computed(() => {
  if (showAuthSection.value) {
    return "Please sign in or sign up before continuing.";
  }

  if (locale.value === "US") {
    return `Tip: Buy a Makercart with 4 activities for the biggest savings!`;
  }

  return `Tip: At least 8 activities in a single Makercart are needed to request a quote.`;
});

const goBack = () => {
  router.go(-1);
};

const CHECKOUT_PREFILL_KEY = "eddy_makercrate_checkout_prefill";
/** @type {import('vue').Ref<'quote' | 'checkout' | null>} */
const pendingAuthAction = ref(null);

const storeCheckoutPrefill = (email = "") => {
  try {
    sessionStorage.setItem(
      CHECKOUT_PREFILL_KEY,
      JSON.stringify({
        organization_name: quoteFormData.value.organization_name,
        attention_to: quoteFormData.value.attention_to,
        address: quoteFormData.value.address,
        city: quoteFormData.value.city,
        state: quoteFormData.value.state,
        zip: quoteFormData.value.zip || "",
        country: quoteFormData.value.country || "United States",
        email:
          email ||
          user.value?.email ||
          localStorage.getItem("guestEmail") ||
          "",
      })
    );
  } catch (error) {
    console.warn("Failed to store checkout prefill data:", error);
  }
};

const proceedToInstantCheckout = (email = "") => {
  storeCheckoutPrefill(email);
  router.push({ name: "MakercrateInstantCheckoutPage" });
};

const handleMakercrateInstantCheckout = () => {
  if (!isAuthenticated.value && !user.value) {
    pendingAuthAction.value = "checkout";
    showAuthSection.value = true;
    showProgressBarAfterAuth.value = true;
    trackProcessStep();
    return;
  }

  proceedToInstantCheckout(user.value?.email || "");
};

// Modal states
const showDeleteModal = ref(false);
const showDuplicateModal = ref(false);
const showMoveModal = ref(false);
const showBundleModal = ref(false);
const showSendQuoteModal = ref(false);
const showQuoteRequestedModal = ref(false);
const showDeleteSingleActivityModal = ref(false);
const showDeleteMakercrateModal = ref(false);
const selectedCartId = ref(null);
const selectedMakercrateId = ref(null);
const selectedCartType = ref(null);
const selectedActivity = ref(null);
const isRequestingQuote = ref(false);
const isSendingQuote = ref(false);
const isDownloadingQuote = ref(false);
const originalCartNames = ref({});
const showQuoteForm = ref(false);
const quoteFormData = ref({
  organization_name: "",
  attention_to: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  country: "United States",
});

// Quantity update state
const isUpdatingQuantity = ref({});
const quantityUpdateTimers = ref({});

const addActivity = () => {
  router.push({
    name: "MakerCartPage",
  });
};

const handleDeleteClick = (cartId) => {
  selectedCartId.value = cartId;
  showDeleteModal.value = true;
};

const handleDeleteMakercrateClick = (makercrateId) => {
  selectedMakercrateId.value = makercrateId;
  showDeleteMakercrateModal.value = true;
};

const handleDeleteMakercrateConfirm = async () => {
  if (!selectedMakercrateId.value) return;
  try {
    // Makercrates are bundle rows — same delete endpoint as a Makercart
    await deleteCart(selectedMakercrateId.value);
    notify.plain("Makercrate deleted successfully");
  } catch (error) {
    console.error("Error deleting makercrate:", error);
    notify.error("Failed to delete makercrate");
  } finally {
    selectedMakercrateId.value = null;
    showDeleteMakercrateModal.value = false;
  }
};

const handleDeleteMakercrateCancel = () => {
  selectedMakercrateId.value = null;
  showDeleteMakercrateModal.value = false;
};

const handleDuplicateClick = (cartId, cartType) => {
  selectedCartId.value = cartId;
  selectedCartType.value = cartType;
  showDuplicateModal.value = true;
};

const handleDeleteConfirm = async () => {
  if (!selectedCartId.value) return;
  await deleteCart(selectedCartId.value);
  selectedCartId.value = null;
  showDeleteModal.value = false;
};

const handleDuplicateConfirm = async () => {
  if (!selectedCartId.value) return;
  await duplicateCart(selectedCartId.value, selectedCartType.value);
  selectedCartId.value = null;
  showDuplicateModal.value = false;
  selectedCartType.value = null;
};

const handleDeleteCancel = () => {
  selectedCartId.value = null;
};

const handleDuplicateCancel = () => {
  selectedCartId.value = null;
};

const handleEditActivity = ({ activity, index }) => {
  console.log("Edit activity:", activity, "at index:", index);
};

const handleRemoveActivity = ({ activity, index }) => {
  console.log("Remove activity:", activity, "at index:", index);
};

const handleActivityConverted = (payload) => {
  console.log("Activity converted:", payload);
  // Handle activity conversion if needed, or refresh cart
  syncCartWithAPI();
};

const handleMoveSingleActivity = (activity) => {
  selectedActivity.value = activity;
  showMoveModal.value = true;
};

const handleMoveActivity = async ({ targetCartId, activityData }) => {
  try {
    const result = await handleMakercartSelection(targetCartId, activityData);
    if (result.success) {
      removeSingleActivity(activityData.entry_id || activityData.makercart_id);
      showMoveModal.value = false;
      selectedActivity.value = null;
    } else {
      notify.error(result.error);
      console.error("Failed to move activity:", result.error);
    }
  } catch (error) {
    console.error("Error moving single activity:", error);
    notify.error("Failed to move activity");
  }
};

const handleMoveCancel = () => {
  showMoveModal.value = false;
  selectedActivity.value = null;
};

const handleDeleteSingleActivity = (activity) => {
  selectedActivity.value = activity;
  showDeleteSingleActivityModal.value = true;
};

const handleDeleteSingleActivityConfirm = async () => {
  if (!selectedActivity.value) return;

  try {
    const activityId =
      selectedActivity.value.entry_id || selectedActivity.value.makercart_id;
    await removeSingleActivity(activityId);

    notify.plain("Activity deleted successfully");
    selectedActivity.value = null;
    showDeleteSingleActivityModal.value = false;
  } catch (error) {
    console.error("Error deleting single activity:", error);
    notify.error("Failed to delete activity");
  }
};

const handleDeleteSingleActivityCancel = () => {
  showDeleteSingleActivityModal.value = false;
  selectedActivity.value = null;
};

const handleBundleActivities = () => {
  if (singleActivities.value.length === 0) {
    return;
  }
  showBundleModal.value = true;
};

const handleBundleConfirm = async () => {
  try {
    if (singleActivities.value.length === 0) {
      showBundleModal.value = false;
      return;
    }
    await convertSingleToBundle();

    notify.plain("Activities bundled successfully");
    showBundleModal.value = false;
  } catch (error) {
    console.error("Error bundling activities:", error);
  }
};

const handleBundleCancel = () => {
  showBundleModal.value = false;
};

const handleSaveCartName = async (cartId, newName) => {
  try {
    const cart = findEditableCart(cartId);
    if (!cart) return;

    const trimmedName = newName ? newName.trim() : "";
    if (!trimmedName) {
      notify.error("Cart name cannot be empty");
      return;
    }

    await finishEditingCartName(cartId, trimmedName);
    delete originalCartNames.value[cartId];
    notify.plain("Cart name updated successfully");
  } catch (error) {
    console.error("Error saving cart name:", error);
    notify.error("Failed to update cart name");
  }
};

const handleCancelEditCartName = (cartId) => {
  const cart = findEditableCart(cartId);
  if (cart && originalCartNames.value[cartId]) {
    cart.name = originalCartNames.value[cartId];
    delete originalCartNames.value[cartId];
  }
  cart.isEditing = false;
};

const handleStartEditingCartName = (cartId) => {
  const cart = findEditableCart(cartId);
  if (cart) {
    originalCartNames.value[cartId] = cart.name;
    startEditingCartName(cartId);
  }
};

// Makercrates share the bundle quantity endpoint, so they share these handlers
const getCartArray = (cartType) => {
  if (cartType === "signature") return signatureMakercarts.value;
  if (cartType === "makercrate") return makercrates.value;
  return carts.value;
};

const handleIncreaseQuantity = async (cartId, cartType) => {
  if (isUpdatingQuantity.value[cartId]) {
    return;
  }

  const cart = getCartArray(cartType).find((c) => c.id === cartId);
  if (cart) {
    if (!cart.quantity) {
      cart.quantity = 1;
    }
    const newQuantity = cart.quantity + 1;
    cart.quantity = newQuantity;

    if (quantityUpdateTimers.value[cartId]) {
      clearTimeout(quantityUpdateTimers.value[cartId]);
    }

    quantityUpdateTimers.value[cartId] = setTimeout(async () => {
      isUpdatingQuantity.value[cartId] = true;
      const oldQuantity = newQuantity - 1;

      try {
        await userCartService.updateBundleQuantity(cartId, newQuantity);
        await syncCartWithAPI();
      } catch (error) {
        console.error("Error updating bundle quantity:", error);
        notify.error("Failed to update quantity");
        cart.quantity = oldQuantity;
      } finally {
        isUpdatingQuantity.value[cartId] = false;
      }
    }, 500);
  }
};

const handleDecreaseQuantity = async (cartId, cartType) => {
  if (isUpdatingQuantity.value[cartId]) {
    return;
  }

  const cart = getCartArray(cartType).find((c) => c.id === cartId);
  if (cart) {
    if (!cart.quantity) {
      cart.quantity = 1;
    }
    if (cart.quantity > 1) {
      const newQuantity = cart.quantity - 1;
      cart.quantity = newQuantity;

      if (quantityUpdateTimers.value[cartId]) {
        clearTimeout(quantityUpdateTimers.value[cartId]);
      }
      quantityUpdateTimers.value[cartId] = setTimeout(async () => {
        isUpdatingQuantity.value[cartId] = true;
        const oldQuantity = newQuantity + 1;

        try {
          await userCartService.updateBundleQuantity(cartId, newQuantity);
          await syncCartWithAPI();
        } catch (error) {
          console.error("Error updating bundle quantity:", error);
          notify.error("Failed to update quantity");
          cart.quantity = oldQuantity;
        } finally {
          isUpdatingQuantity.value[cartId] = false;
        }
      }, 500);
    }
  }
};

const handleQuantityInput = (cartId, cartType, event) => {
  const cart = getCartArray(cartType).find((c) => c.id === cartId);
  if (cart) {
    const value = parseInt(event.target.value);
    if (!isNaN(value) && value >= 1) {
      cart.quantity = value;
      console.log(
        `Updated quantity for ${cartType} cart ${cartId}:`,
        cart.quantity
      );
    }
  }
};

const handleQuantityBlur = async (cartId, cartType, event) => {
  if (quantityUpdateTimers.value[cartId]) {
    clearTimeout(quantityUpdateTimers.value[cartId]);
    delete quantityUpdateTimers.value[cartId];
  }

  if (isUpdatingQuantity.value[cartId]) {
    return;
  }

  const cart = getCartArray(cartType).find((c) => c.id === cartId);
  if (cart) {
    const value = parseInt(event.target.value);
    if (isNaN(value) || value < 1) {
      cart.quantity = 1;
      event.target.value = 1;
      console.log(
        `Reset quantity to 1 for ${cartType} cart ${cartId} (invalid input)`
      );
    }

    isUpdatingQuantity.value[cartId] = true;
    try {
      await userCartService.updateBundleQuantity(cartId, cart.quantity);
      await syncCartWithAPI();
    } catch (error) {
      console.error("Error updating bundle quantity:", error);
      notify.error("Failed to update quantity");
    } finally {
      isUpdatingQuantity.value[cartId] = false;
    }
  }
};

const isFormValid = computed(() => {
  return (
    quoteFormData.value.organization_name.trim() !== "" &&
    quoteFormData.value.attention_to.trim() !== "" &&
    quoteFormData.value.address.trim() !== "" &&
    quoteFormData.value.city.trim() !== "" &&
    quoteFormData.value.state.trim() !== ""
  );
});

const handleCancelQuote = () => {
  showQuoteForm.value = false;
};

const handleRequestQuote = async () => {
  // US uses a two-step flow (Next → show form → Generate).
  // SG shows the form immediately, so skip the reveal-only first click.
  if (!showQuoteForm.value) {
    showQuoteForm.value = true;
    if (locale.value !== "SG") {
      return;
    }
  }
  if (!isFormValid.value) {
    notify.error("Please fill in all required fields");
    return;
  }

  if (!isAuthenticated.value && !user.value) {
    pendingAuthAction.value = "quote";
    showAuthSection.value = true;
    showProgressBarAfterAuth.value = true;
    trackProcessStep();
    return;
  }

  try {
    isRequestingQuote.value = true;

    const userEmail = user.value?.email;
    if (!userEmail) {
      notify.error("Email not found. Please try logging in again.");
      return;
    }

    await trackQuoteGeneratedStep(true);
    const result = await requestQuote(userEmail, quoteFormData.value);
    if (result.success) {
      if (locale.value === "US") {
        notify.success(
          "Quote generated successfully! Check your email for details."
        );
      }

      // Reset form
      showQuoteForm.value = false;

      showQuoteRequestedModal.value = true;
    } else {
      notify.error(result.error || "Failed to generate quote");
    }
  } catch (error) {
    console.error("Error requesting quote:", error);
    notify.error("Failed to generate quote");
  } finally {
    isRequestingQuote.value = false;
  }
};

const handleDownloadQuote = async () => {
  isDownloadingQuote.value = true;
  const userEmail = user.value?.email || localStorage.getItem("guestEmail");

  if (!userEmail) {
    notify.error("Email not found. Please try logging in again.");
    return;
  }

  try {
    // Prepare the same data structure as request quote
    const downloadData = {
      email: userEmail,
      organization_name: quoteFormData.value.organization_name,
      attention_to: quoteFormData.value.attention_to,
      address: quoteFormData.value.address,
      city: quoteFormData.value.city,
      state: quoteFormData.value.state,
      zip: quoteFormData.value.zip,
      country: quoteFormData.value.country,
    };

    await userCartService.downloadQuote(cartId.value, downloadData);
    notify.success("Quote downloaded successfully");
  } catch (error) {
    console.error("Error downloading quote:", error);
    notify.error("Failed to download quote");
  } finally {
    isDownloadingQuote.value = false;
  }
};

const handleResendQuote = () => {
  showSendQuoteModal.value = true;
};

const handleSendQuote = async ({ email }) => {
  try {
    isSendingQuote.value = true;

    notify.success(`Quote sent to ${email}`);
    showSendQuoteModal.value = false;
  } catch (error) {
    console.error("Error sending quote:", error);
    notify.error("Failed to send quote");
  } finally {
    isSendingQuote.value = false;
  }
};

const handleSendQuoteCancel = () => {
  showSendQuoteModal.value = false;
};

const handleAuthSuccess = async (data) => {
  const wasFormValid = isFormValid.value; // Capture valid state early
  const action = pendingAuthAction.value;
  pendingAuthAction.value = null;

  isAuthenticated.value = true;
  showAuthSection.value = false;

  await updateUserState();

  // Ensure these are set correctly after store update (which triggers watcher)
  showProgressBarAfterAuth.value = true;
  showAuthSection.value = false;

  if (action === "checkout") {
    const userEmail = user.value?.email || data?.email || "";
    proceedToInstantCheckout(userEmail);
    return;
  }

  if (action === "quote" && wasFormValid) {
    try {
      isRequestingQuote.value = true;

      const userEmail = user.value?.email || data?.email;
      console.log("User email:", userEmail);

      if (!userEmail) {
        notify.error("Email not found. Please try logging in again.");
        return;
      }

      // Track Process step again (trackView=false, trackProcess=true)
      await trackQuoteGeneratedStep(false, true);
      const result = await requestQuote(userEmail, quoteFormData.value);

      if (result.success) {
        notify.success(
          "Quote generated successfully! Check your email for details."
        );
        showQuoteForm.value = false;

        showQuoteRequestedModal.value = true;
      } else {
        notify.error(result.error || "Failed to generate quote");
      }
    } catch (error) {
      console.error("Error requesting quote after auth:", error);
      notify.error("Failed to generate quote");
    } finally {
      isRequestingQuote.value = false;
    }
  }
};

const handleGuestAuthSuccess = async (data) => {
  const action = pendingAuthAction.value;
  pendingAuthAction.value = null;

  isAuthenticated.value = true;
  showAuthSection.value = false;

  const guestEmail = data?.email || localStorage.getItem("guestEmail");

  if (action === "checkout") {
    if (!guestEmail) {
      notify.error("Email not found. Please try logging in again.");
      return;
    }
    proceedToInstantCheckout(guestEmail);
    return;
  }

  if (action === "quote" && isFormValid.value) {
    try {
      isRequestingQuote.value = true;

      if (!guestEmail) {
        notify.error("Email not found. Please try logging in again.");
        return;
      }

      // Track Process step again (trackView=false, trackProcess=true)
      await trackQuoteGeneratedStep(false, true);
      const result = await requestQuote(guestEmail, quoteFormData.value);
      if (result.success) {
        notify.success(
          "Quote generated successfully! Check your email for details."
        );
        showQuoteForm.value = false;

        showQuoteRequestedModal.value = true;
      } else {
        notify.error(result.error || "Failed to generate quote");
      }
    } catch (error) {
      console.error("Error requesting quote after guest auth:", error);
      notify.error("Failed to generate quote");
    } finally {
      isRequestingQuote.value = false;
    }
  }
};

watch(isMakercrateOnlyCart, (isCrateOnly) => {
  if (isCrateOnly) {
    showQuoteForm.value = false;
  }
});

watch(
  user,
  (newUser) => {
    isAuthenticated.value = !!newUser;
    if (isAuthenticated.value) {
      // If user logs in while auth section is open, trigger success handler
      if (showAuthSection.value) {
        console.log("User logged in via watcher, triggering handleAuthSuccess");
        handleAuthSuccess(newUser);
      } else {
        showProgressBarAfterAuth.value = false;
      }
    }
  },
  { immediate: true }
);

onMounted(async () => {
  syncCartWithAPI();

  isAuthenticated.value = await isUserAuthenticated();

  if (isAuthenticated.value) {
    showProgressBarAfterAuth.value = false;
  }
});

onBeforeUnmount(() => {
  Object.values(quantityUpdateTimers.value).forEach((timer) => {
    if (timer) clearTimeout(timer);
  });
  quantityUpdateTimers.value = {};

  resetCart();
});
</script>

<style scoped>
@import "@/assets/css/colors.css";

.makercart-cart-page {
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 100vh;
  border-top: 1px solid #d8dae5;
  background-color: var(--white);
}

.mobile-top-app-bar {
  display: none;
}

.header-section {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* Progress Bar */
.cart-progress-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
}

.progress-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.progress-icon {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white);
  border-radius: 64px;
  padding: 2px;
}

.icon-border {
  width: 100%;
  height: 100%;
  border-radius: 64px;
  border: 3px solid var(--primary-green);
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-border::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 9px;
  height: 9px;
  background-color: var(--primary-green);
  border-radius: 50%;
}

.icon-border.inactive::after {
  background-color: #98a2b3;
}

.icon-border.inactive {
  border-color: #98a2b3;
}

.progress-icon-img {
  width: 16px;
  height: 16px;
}

.progress-number {
  font-family: "League Spartan", sans-serif;
  font-size: var(--fs-small);
  font-weight: 600;
  color: #98a2b3;
}

.progress-label {
  font-family: "League Spartan", sans-serif;
  font-size: var(--fs-large);
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  white-space: nowrap;
}

.progress-label-mobile {
  display: none;
}

.progress-label.active {
  color: var(--black-body-text);
}

.progress-label.inactive {
  color: var(--neutral-700);
}

.progress-line {
  flex: 1;
  height: 5px;
  border-radius: 10px;
  background-color: #e5e7eb;
  margin: 0 16px;
}

.active-progress-line {
  background-color: var(--primary-green);
}

/* Divider Line */
.divider-line {
  width: 100%;
  height: 1px;
  background-color: #e5e7eb;
}

/* Back Button */
.back-button-container {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
}

.back-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon img {
  width: 30px;
  height: 30px;
}

.back-text {
  font-family: "League Spartan", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  color: var(--primary-blue);
}

/* Cart Summary Section */
.cart-summary-section {
  display: flex;
  gap: 32px;
  align-items: flex-start;
  width: 100%;
}

/* Auth Section Container */
.auth-section-container {
  width: 100%;
  background-color: var(--white);
  padding: 0;
}

.cart-content-area {
  flex: 1;
  transition: all 0.3s ease-in-out;
}

/* Carts Container */
.carts-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .cart-summary-section {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .makercart-cart-page {
    padding: 0;
    gap: 16px;
    border-top: 0;
    padding-bottom: 220px;
  }

  .mobile-top-app-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 64px;
    padding: 0 4px;
    border-bottom: 1px solid #d8dae5;
    background-color: var(--white);
  }

  .mobile-top-app-bar__icon {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 0;
    padding: 0;
  }

  .mobile-top-app-bar__icon img {
    width: 24px;
    height: 24px;
  }

  .mobile-top-app-bar__title {
    flex: 1;
    font-family: "League Spartan", sans-serif;
    font-size: var(--fs-medium);
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0.024px;
    color: var(--primary-blue);
  }

  .header-section {
    gap: 16px;
    padding: 0;
  }

  .cart-progress-bar {
    padding: 16px 16px 0 16px;
    gap: 8px;
  }

  .cart-progress-bar svg {
    width: 24px;
    height: 24px;
  }

  .progress-section {
    gap: 8px;
  }

  .progress-icon {
    width: 24px;
    height: 24px;
    padding: 1.2px;
  }

  .icon-border {
    border-width: 1.8px;
  }

  .icon-border::after {
    width: 6px;
    height: 6px;
  }

  .progress-label {
    font-size: var(--fs-small);
    line-height: 20px;
    letter-spacing: 0.014px;
  }

  .progress-label-desktop {
    display: none;
  }

  .progress-label-mobile {
    display: inline;
  }

  .divider-line {
    display: none;
  }

  .progress-label.inactive {
    color: var(--neutral-700);
  }

  .progress-line {
    margin: 0;
  }

  /* Multiple Carts Responsive */
  .carts-container {
    gap: 16px;
  }

  .back-button-container {
    display: none;
  }

  .cart-summary-section {
    padding: 0 16px;
  }

  .cart-content-area {
    width: 100%;
    padding-bottom: 16px;
  }

  .makercart-cart-page :deep(.cart-header) {
    padding: 0;
    border: none;
    margin-top: 16px;
    padding: 0px 16px;
  }

  .makercart-cart-page :deep(.cart-title) {
    font-size: var(--fs-large);
    line-height: 28px;
  }

  .makercart-cart-page :deep(.cart-subtitle) {
    font-size: var(--fs-small);
    line-height: 20px;
    text-align: left;
    width: 100%;
  }

  .makercart-cart-page :deep(.cart-actions) {
    display: flex !important;
    width: 100%;
    gap: 0px;
  }

  .makercart-cart-page :deep(.btn-view-details) {
    display: none !important;
  }

  .makercart-cart-page :deep(.btn-add-cart) {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    font-size: var(--fs-small);
    line-height: 20px;
    justify-content: center;
  }

  .makercart-cart-page :deep(.btn-add-cart svg) {
    width: 16px;
    height: 16px;
  }

  .makercart-cart-page :deep(.tip-banner) {
    border-radius: 0;
    margin: 0;
    padding: 16px;
    gap: 16px;
  }

  .makercart-cart-page :deep(.tip-icon) {
    width: 16px;
    height: 16px;
  }

  .makercart-cart-page :deep(.tip-text) {
    font-size: var(--fs-small);
    line-height: 20px;
  }

  .makercart-cart-page :deep(.empty-cart-container) {
    width: 100%;
    height: 116px;
    border-width: 1px;
    border-color: #0478ce;
    margin-top: 20%;
  }

  .makercart-cart-page :deep(.add-new-cart-btn) {
    padding: 10px 16px;
    gap: 8px;
    border-radius: 12px;
  }

  .makercart-cart-page :deep(.add-cart-text) {
    font-family: "League Spartan", sans-serif;
    font-size: var(--fs-medium);
    line-height: 24px;
    letter-spacing: 0.024px;
  }

  .makercart-cart-page :deep(.price-summary) {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 393px;
    max-width: 100%;
    border: 1px solid #d8dae5;
    border-radius: 12px 12px 0 0;
    box-shadow: none;
    z-index: 50;
  }

  .makercart-cart-page :deep(.price-summary)::before {
    content: "";
    display: block;
    width: 16px;
    height: 2px;
    border-radius: 2px;
    background-color: #40444b;
    margin: 0 auto 16px;
  }

  .makercart-cart-page :deep(.price-label),
  .makercart-cart-page :deep(.price-value) {
    line-height: 24px;
  }
}
</style>
